<template>
    <div ref="gauge" class="container"></div>
</template>

<script>
import echarts from 'echarts';
import {relationScatterData} from '@/runtime-components/data';
import {gauge} from '@/runtime-components/config/chart.config'

export default {
    name: 'de-gauge',
    props: {
        title: {
            type: String,
            default: '速度'
        }, 
        val: {
            type: Number,
            default: 35
        }, 
        unit: {
            type: String,
            default: 'km/h'
        }
    },
    data() {
        let chartIns = {
            chart: null,
            option: []
        };
        return {
            getChart() {
                return chartIns;
            }
        }
    },
    mounted() {
        this.initChart();
    },
    destroyed(){
        this.destroyChart();
    },
    watch: {
        unit(v) {
            let chart = this.getChart().chart;
            chart && (chart.setOption({
                tooltip: {
                    formatter: () => {
                        return `${this.title} <br/>${this.val} ${v}`
                    }
                },
                series: [{
                    data: [{value: this.val, name: v}]
                }]
            }));
        },
        val(v) {
            let chart = this.getChart().chart;
            chart && (chart.setOption({
                tooltip: {
                    formatter: () => {
                        return `${this.title} <br/>${v} ${this.unit}`
                    }
                },
                series: [{
                    data: [{value: v, name: this.unit}]
                }]
            }));
        },
        title(v) {
            let chart = this.getChart().chart;
            chart && (chart.setOption({
                tooltip: {
                    formatter: () => {
                        return `${v} <br/>${this.val} ${this.unit}`
                    }
                },
                series: [{
                    data: [{value: this.val, name: this.unit}]
                }]
            }));
        }
    },
    methods: {
        initChart() {
            let chartIns = this.getChart();
            if (!chartIns.chart) {
                chartIns.chart = echarts.init(this.$refs['gauge']);
                let option = gauge(this.title, this.val, this.unit);
                chartIns.chart.setOption(option);
                this.resizeChart = chartIns.chart.resize;
            }
        },
        destroyChart() {
            const chartIns = this.getChart();
            if(chartIns.chart){
               chartIns.chart.dispose();
               chartIns.chart = null;
            }
        }
    }
}
</script>

<style lang="less">
@import url('~@/runtime-components/assets/common.css');
</style>